import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "./Button";

const PopupRegisterForm = ({ onClose }) => {
  const [formData, setFormData] = useState({ name: "", phone: "", email: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);

    const payload = {
      name: formData.name,
      phone: formData.phone,
      email: "", // Intentionally left blank
      age: "",
      gender: "",
      city: "",
      date_suits: "",
      price_suitable: "",
      reason: "",
      question: formData.email,
    };

    try {
      // ✅ Submit to backend Lambda
      await fetch("https://zbpje4azgliercmqvfqkh34bqm0mlmwm.lambda-url.ap-south-1.on.aws/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      // ✅ Send data to Pabbly webhook
      await fetch("https://connect.pabbly.com/workflow/sendwebhookdata/IjU3NjYwNTZhMDYzMjA0MzE1MjZhNTUzMTUxM2Ii_pc", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: formData.name,
          phone: formData.phone,
          email: formData.email,
        }),
      });

      setShowThankYou(true);
      setFormData({ name: "", phone: "", email: "" });

      setTimeout(() => {
        navigate("/retreats/innergise/book-oct-retreat");
      }, 2000);
    } catch (err) {
      console.error(err);
      alert("❌ Failed to register. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[999]">
      <div className="bg-white p-6 rounded-lg w-full max-w-md shadow-xl relative">
        <button
          onClick={onClose}
          className="absolute top-2 right-3 text-xl text-gray-600 hover:text-black"
        >
          &times;
        </button>

        {!showThankYou ? (
          <>
            <h2 className="text-xl font-bold text-center mb-1">Book Now</h2>
            <p className="text-center text-gray-600 text-sm mb-4">
              The Innergise Retreat Begins With a Simple Step
            </p>

            <form onSubmit={handleSubmit} className="space-y-4">
              <input
                type="text"
                name="name"
                placeholder="First Name"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full border rounded p-2"
              />
              <input
                type="tel"
                name="phone"
                placeholder="Whatsapp Number"
                value={formData.phone}
                onChange={handleChange}
                required
                pattern="[0-9]{10}"
                className="w-full border rounded p-2"
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full border rounded p-2"
              />

              <Button
                text={isSubmitting ? "Submitting..." : "Submit"}
                type="submit"
                variant="primary"
                className="w-full"
                disabled={isSubmitting}
              />
            </form>
          </>
        ) : (
          <div className="text-center py-10">
            <h3 className="text-lg font-semibold text-green-600">✅ Thank You!</h3>
            <p className="mt-2 text-sm text-gray-600">
              Your registration was successful. Redirecting...
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PopupRegisterForm;
